import {
  CreateBookTestBookingPayload,
  CreateBookTestBookingResponse,
  GetMyPaidBookTestBookingsResponse,
  PaidBookTestBooking,
} from "@/store/types/bookExamTypes";
import axiosInstance from "@/utils/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createBookTestBooking = createAsyncThunk<
  CreateBookTestBookingResponse,
  CreateBookTestBookingPayload,
  { rejectValue: string }
>("bookExam/createBookTestBooking", async (payload, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post<CreateBookTestBookingResponse>(
      "/book-test",
      payload,
    );

    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message;

    if (Array.isArray(message)) {
      return rejectWithValue(message.join(", "));
    }

    return rejectWithValue(
      message || error?.message || "Failed to save booking details.",
    );
  }
});

export const getMyPaidBookTestBookings = createAsyncThunk<
  PaidBookTestBooking[],
  void,
  { rejectValue: string }
>("bookExam/getMyPaidBookTestBookings", async (_, { rejectWithValue }) => {
  try {
    const { data } =
      await axiosInstance.get<GetMyPaidBookTestBookingsResponse>(
        "/book-test/my-bookings",
      );

    return Array.isArray(data.data) ? data.data : [];
  } catch (error: any) {
    const message = error?.response?.data?.message;

    if (Array.isArray(message)) {
      return rejectWithValue(message.join(", "));
    }

    return rejectWithValue(
      message || error?.message || "Failed to fetch paid bookings.",
    );
  }
});
